module.exports = __webpack_public_path__ + "img/question-square.54e95d06.svg";